import { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import img1 from '../../assets/Page_1/1.2_Recomendaciones/pexels-cottonbro-5077039.jpg'
import img2 from '../../assets/Page_1/1.2_Recomendaciones/mitchell-griest-fbXHHCiheVM-unsplash.jpg'
import img3 from '../../assets/Page_1/1.2_Recomendaciones/k8-r87zX1RWECQ-unsplash.jpg'
import './Slider.css'

const Slider = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const cards = [
    {
      image: img1,
      description: '<strong>Evita el brillo excesivo</strong> ajustando iluminación en pantallas y habitaciones.'
    },
    {
      image: img2,
      description: '<strong>Descansa tus ojos</strong> siguiendo la regla 20-20-20: cada 20 minutos mira algo a 20 pies (6 metros) por 20 segundos.'
    },
    {
      image: img3,
      description: '<strong>Usa lentes de filtro azul</strong> al encontrarte frente a monitores y pantallas.'
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % cards.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [cards.length]);

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  const handlePrev = () => {
    setActiveIndex((prev) => (prev - 1 + cards.length) % cards.length);
  };

  const handleNext = () => {
    setActiveIndex((prev) => (prev + 1) % cards.length);
  };

  return (
    <div className="health-slider">
      <div className="cards-container">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`card ${activeIndex === index ? 'active' : ''} ${
              hoveredIndex === index ? 'hovered' : ''
            }`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}
            onClick={() => handleDotClick(index)}
          >
            <div className="card-image">
              <img src={card.image} alt={card.title} />
            </div>
            <div className="card-content">
              <p 
                className="card-description"
                dangerouslySetInnerHTML={{ __html: card.description }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Flechas para mobile */}
      <div className="navigation-arrows">
        <button 
          className="arrow-btn prev" 
          onClick={handlePrev}
          aria-label="Previous slide"
        >
          <ChevronLeft size={24} />
        </button>
        <button 
          className="arrow-btn next" 
          onClick={handleNext}
          aria-label="Next slide"
        >
          <ChevronRight size={24} />
        </button>
      </div>

      <div className="dots">
        {cards.map((_, index) => (
          <button
            key={index}
            className={`dot ${activeIndex === index ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;